<template>
    <div v-show="src">
        <viewer
            :options="options"
            @inited="inited"
            class="viewer"
            ref="viewer"
            :images="urls"
        >
            <template slot-scope="scope">
                <img :src="src" ref="preview" @click="show" style="cursor: pointer; width: 100%;">
                <img v-for="src in scope.images" :src="src" :key="src" style="display: none;">
                <br />
                <div style="color: gray; font-size: 10pt; text-align: center;">
                    Kliknij w zdjęcie, aby je powiększyć i zobaczyć wszystkie zdjęcia
                </div>
            </template>
        </viewer>
    </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from "v-viewer/src/component.vue";
import cloneDeep from 'lodash.clonedeep';

const DEFAULT_VIEWER_OPTIONS = {
    inline: false,
    button: false,
    navbar: true,
    title: false,
    toolbar: {
        zoomIn: true,
        zoomOut: true,
        oneToOne: true,
        reset: true,
        rotateLeft: true,
        rotateRight: true
    },
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: false,
    transition: true,
    fullscreen: true,
    keyboard: true,
    filter: image => {
        return image !== this.$refs.preview;
    },
};

export default {
    components: {Viewer},
    props: {
        images: {
            type: Array,
        },
        viewerOptions: {
            type: Object,
            required: false,
        }
    },
    data() {

        let src = null;
        let urls = null;

        if (this.images && this.images.length) {
            src = this.images[0];
            urls = this.images;
        }

        return {
            src,
            urls,
            options: Object.assign(cloneDeep(DEFAULT_VIEWER_OPTIONS), cloneDeep(this.viewerOptions || {}), {
                filter: image => {
                    return image !== this.$refs.preview;
                },
                title: image => {
                    if (!this.viewerOptions || !this.viewerOptions.title) {
                        return '';
                    }

                    let pageSuffix = '';
                    if (this.urls.length > 1) {
                        pageSuffix = `, strona ${this.urls.indexOf(image.src) + 1}`;
                    }
                    return this.viewerOptions.title() + pageSuffix;
                },
            }),
        };
    },
    methods: {
        inited(viewer) {
            this.$viewer = viewer;
        },
        show() {
            this.$viewer.show();
        },
        hide() {
            this.src = null;
            this.urls = [];
            this.$viewer.hide();
        },
    },
    watch: {
        images(value) {
            this.src = value[0];
            this.urls = value;
            this.options.navbar = value.length > 1;

            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            },1000)

        },
    }
}

</script>
